import React, { useContext } from 'react';
import NRAutocompleteFilter from '../../NRAutocompleteFilter/NRAutocompleteFilter';
import useFetchLicensesSpdxIds from '../../NRLicense/useFetchLicensesSpdxIds';
import { GenericContext } from '../../GenericContext/GenericContextWrapper';
import { CONSTANTS } from '../../../constants/constants';

const LicenseListDropdown = ({ value, setValue }) => {
  const { licensesSpdxIds, licensesSpdxIdsLoading } = useContext(GenericContext);
  useFetchLicensesSpdxIds();
  const valueIsArray = Array.isArray(value);
  const valueToUse = valueIsArray ? (value?.length > 1 ? CONSTANTS.LICENSES.MULTIPLE_LICENSES_PLACEHOLDER : value[0]) : value;
  return (
    <NRAutocompleteFilter
      showMultipleLicensesWarning={valueIsArray && value?.length > 1}
      value={valueToUse}
      setValue={setValue}
      options={licensesSpdxIds}
      placeholder={!!licensesSpdxIdsLoading ? 'Loading Licenses...' : 'License'}
      filterPlaceholder="Select or type your license"
    />
  );
};

export default LicenseListDropdown;
